module.exports = __webpack_public_path__ + "static/img/happy2.b9c9a06b.png";